<template>
  <v-dialog
    :value="value"
    max-width="1380"
    scrollable
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title class="text-subtitle-1">
        Estatus de prospectos
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row dense align="center">
          <v-col cols="6" sm="3" md="2">
            <v-text-field
              v-model="desde"
              label="Desde"
              type="date"
              filled
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="3" md="2">
            <v-text-field
              v-model="hasta"
              label="Hasta"
              type="date"
              filled
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" class="text-caption grey--text">
            Cuenta el primer mensaje de la conversación. Cada caja es la suma de las que salen de ella.
          </v-col>
        </v-row>
        <v-alert v-if="errorEmbudo" dense text type="error" class="mt-3 mb-0">
          {{ errorEmbudo }}
        </v-alert>

        <div class="arbol-scroll mt-4">
          <div class="org">
            <button type="button" class="caja" :class="{ 'caja--activa': nodo === 'conversaciones' }" @click="nodo = 'conversaciones'">
              <span class="caja__titulo">Número de conversaciones</span>
              <span class="caja__num">{{ total('conversaciones') }}</span>
            </button>
            <div class="org-hijos">
              <div class="org-rama">
                <button type="button" class="caja" :class="{ 'caja--activa': nodo === 'con_cv' }" @click="nodo = 'con_cv'">
                  <span class="caja__titulo">Mandaron CV</span>
                  <span class="caja__num">{{ total('con_cv') }}</span>
                </button>
                <div class="org-hijos">
                  <div class="org-rama">
                    <button type="button" class="caja" :class="{ 'caja--activa': nodo === 'aplica' }" @click="nodo = 'aplica'">
                      <span class="caja__titulo">Aplica</span>
                      <span class="caja__num">{{ total('aplica') }}</span>
                    </button>
                    <div class="org-hijos">
                      <div class="org-rama">
                        <button type="button" class="caja" :class="{ 'caja--activa': nodo === 'concreto' }" @click="nodo = 'concreto'">
                          <span class="caja__titulo">Concretó cita</span>
                          <span class="caja__num">{{ total('concreto') }}</span>
                        </button>
                        <div class="org-hijos">
                          <div class="org-rama">
                            <button type="button" class="caja" :class="{ 'caja--activa': nodo === 'asistio' }" @click="nodo = 'asistio'">
                              <span class="caja__titulo">Asistió</span>
                              <span class="caja__num">{{ total('asistio') }}</span>
                            </button>
                          </div>
                          <div class="org-rama">
                            <button type="button" class="caja" :class="{ 'caja--activa': nodo === 'no_asistio' }" @click="nodo = 'no_asistio'">
                              <span class="caja__titulo">No asistió</span>
                              <span class="caja__num">{{ total('no_asistio') }}</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="org-rama">
                        <button type="button" class="caja" :class="{ 'caja--activa': nodo === 'no_concreto' }" @click="nodo = 'no_concreto'">
                          <span class="caja__titulo">No concretó cita</span>
                          <span class="caja__num">{{ total('no_concreto') }}</span>
                        </button>
                      </div>
                      <div class="org-rama">
                        <button type="button" class="caja" :class="{ 'caja--activa': nodo === 'nc_aplica' }" @click="nodo = 'nc_aplica'">
                          <span class="caja__titulo">No contesta</span>
                          <span class="caja__num">{{ total('nc_aplica') }}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="org-rama">
                    <button type="button" class="caja" :class="{ 'caja--activa': nodo === 'no_aplica' }" @click="nodo = 'no_aplica'">
                      <span class="caja__titulo">No aplica</span>
                      <span class="caja__num">{{ total('no_aplica') }}</span>
                    </button>
                  </div>
                  <div class="org-rama">
                    <button type="button" class="caja" :class="{ 'caja--activa': nodo === 'nc_cv' }" @click="nodo = 'nc_cv'">
                      <span class="caja__titulo">No contesta</span>
                      <span class="caja__num">{{ total('nc_cv') }}</span>
                    </button>
                  </div>
                  <div class="org-rama">
                    <button type="button" class="caja" :class="{ 'caja--activa': nodo === 'sin_decision' }" @click="nodo = 'sin_decision'">
                      <span class="caja__titulo">Sin decisión</span>
                      <span class="caja__num">{{ total('sin_decision') }}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="org-rama">
                <button type="button" class="caja" :class="{ 'caja--activa': nodo === 'sin_cv' }" @click="nodo = 'sin_cv'">
                  <span class="caja__titulo">No mandaron CV</span>
                  <span class="caja__num">{{ total('sin_cv') }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="text-subtitle-2 mt-4">{{ tituloNodo }} · {{ total(nodo) }}</div>
        <div class="text-caption grey--text mb-2">{{ significado }}</div>
        <v-data-table
          dense
          elevation="0"
          :headers="headers"
          :items="personasNodo"
          :loading="cargando"
          item-key="_key"
          no-data-text="Nadie en este estatus para esas fechas."
        ></v-data-table>
      </v-card-text>
    </v-card>
    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
  </v-dialog>
</template>

<script>
import Alerta from '@/components/alertas/Alerta.vue'
import validarErrores from '@/mixins/validarErrores'

function ymdLocal (d) {
  const mes = d.getMonth() + 1
  const dia = d.getDate()
  return d.getFullYear() + '-'
    + (mes < 10 ? '0' : '') + mes + '-'
    + (dia < 10 ? '0' : '') + dia
}

const HOJAS = {
  conversaciones: ['sin_cv', 'no_aplica', 'nc_cv', 'sin_decision', 'asistio', 'no_asistio', 'no_concreto', 'nc_aplica'],
  con_cv: ['no_aplica', 'nc_cv', 'sin_decision', 'asistio', 'no_asistio', 'no_concreto', 'nc_aplica'],
  sin_cv: ['sin_cv'],
  aplica: ['asistio', 'no_asistio', 'no_concreto', 'nc_aplica'],
  no_aplica: ['no_aplica'],
  nc_cv: ['nc_cv'],
  sin_decision: ['sin_decision'],
  concreto: ['asistio', 'no_asistio'],
  asistio: ['asistio'],
  no_asistio: ['no_asistio'],
  no_concreto: ['no_concreto'],
  nc_aplica: ['nc_aplica'],
}

const TITULOS = {
  conversaciones: 'Número de conversaciones',
  con_cv: 'Mandaron CV',
  sin_cv: 'No mandaron CV',
  aplica: 'Aplica',
  no_aplica: 'No aplica',
  nc_cv: 'No contesta',
  sin_decision: 'Sin decisión',
  concreto: 'Concretó cita',
  asistio: 'Asistió',
  no_asistio: 'No asistió',
  no_concreto: 'No concretó cita',
  nc_aplica: 'No contesta',
}

export default {
  name: 'TwilioRhEmbudo',
  components: { Alerta },
  mixins: [validarErrores],
  props: {
    value: { type: Boolean, default: false },
  },
  data () {
    const d = new Date()
    const inicio = new Date(d.getFullYear(), d.getMonth(), 1)
    return {
      desde: ymdLocal(inicio),
      hasta: ymdLocal(d),
      nodo: 'conversaciones',
      nodos: {},
      significados: {},
      personas: [],
      cargando: false,
      errorEmbudo: '',
      headers: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'Teléfono', value: 'telefono' },
        { text: 'Vacante', value: 'puesto' },
        { text: 'Primer mensaje', value: 'fecha' },
      ],
    }
  },
  computed: {
    tituloNodo () {
      return TITULOS[this.nodo] || 'Prospectos'
    },
    significado () {
      const map = this.significados || {}
      return map[this.nodo] || ''
    },
    personasNodo () {
      const hojas = HOJAS[this.nodo] || []
      const out = []
      const lista = this.personas || []
      for (let i = 0; i < lista.length; i++) {
        if (hojas.indexOf(lista[i].hoja) === -1) continue
        out.push(Object.assign({ _key: String(i) + '-' + (lista[i].telefono || '') }, lista[i]))
      }
      return out
    },
  },
  watch: {
    value (abierto) {
      if (abierto) this.cargarEmbudo()
    },
    desde () {
      if (this.value) this.cargarEmbudo()
    },
    hasta () {
      if (this.value) this.cargarEmbudo()
    },
  },
  methods: {
    total (key) {
      const n = this.nodos || {}
      return n[key] || 0
    },
    mensajeError (error) {
      if (error && error.response && error.response.data && error.response.data.message) {
        return error.response.data.message
      }
      if (typeof error === 'string') return error
      return 'No se pudo cargar el estatus de prospectos'
    },
    cargarEmbudo () {
      if (!this.desde || !this.hasta || this.desde > this.hasta) {
        this.errorEmbudo = 'El rango de fechas no es válido'
        return
      }
      this.cargando = true
      this.errorEmbudo = ''
      return this.$http.post('twilio-rh.reporte.embudo', {
        desde: this.desde,
        hasta: this.hasta,
      }).then((response) => {
        const data = response.data || {}
        this.significados = data.significados || {}
        this.nodos = data.nodos || {}
        this.personas = data.personas || []
      }).catch((error) => {
        this.significados = {}
        this.nodos = {}
        this.personas = []
        this.errorEmbudo = this.mensajeError(error)
      }).finally(() => {
        this.cargando = false
      })
    },
  },
}
</script>

<style scoped>
.arbol-scroll {
  overflow-x: auto;
  padding-bottom: 8px;
}
.org {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 920px;
}
.org-hijos {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 2px solid #e0c36a;
  position: relative;
}
.org-hijos::before {
  content: '';
  position: absolute;
  top: -16px;
  left: 50%;
  height: 16px;
  border-left: 2px solid #e0c36a;
}
.org-rama {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.caja {
  min-width: 132px;
  max-width: 168px;
  background: #fff8e1;
  border: 1px solid #f0d78c;
  border-radius: 6px;
  padding: 8px 10px;
  text-align: center;
  cursor: pointer;
}
.caja--activa {
  border-color: #f9a825;
  box-shadow: 0 0 0 2px #f9a825;
}
.caja__titulo {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #5d4037;
  line-height: 1.2;
}
.caja__num {
  display: block;
  margin-top: 2px;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.1;
  color: #3e2723;
}
</style>
